import React, { Component } from 'react';
import { Spin } from 'antd';
import TableC from '../../basicElement/TableC';
import ImportantEventTable from '../ImportantEventTable';

class MinusContent extends Component {
    getMinusTable = () => {
        const { restDatas: { minusData = [] } } = this.props;
        const getColumns = () => {
            const columns = [{
                title: '考核项',
                dataIndex: 'itemName',
                key: 'itemName',
                render: (text, record) => {
                    if (text.startsWith('合计')) {
                        return <strong>{text}</strong>;
                    }
                    return text;
                }
            }, {
                title: '得分',
                dataIndex: 'score',
                key: 'score',
                width: 370,
                render: (text, record) => {
                    if (record.itemName.startsWith('合计')) {
                        return <strong>{text}</strong>;
                    }
                    return text;
                }
            }];
            return columns;
        };

        return (
            <TableC
                data={minusData}
                columns={getColumns()}
                rowKey="performanceItemId"
                pagination={false}
            />
        )
    }

    render() {
        const { loading, restDatas: { majorEvent = [] } } = this.props;
        return (
            <Spin spinning={loading}>
                <div style={{ lineHeight: '48px' }}>1.减分明细</div>
                {this.getMinusTable()}
                <div style={{ lineHeight: '48px' }}>2.重大事件发生明细</div>
                {<ImportantEventTable data={majorEvent} />}
            </Spin>
        );
    }
}

export default MinusContent;


// WEBPACK FOOTER //
// ./src/components/home/leaderPerformanceDetail/MinusContent.js